import {
  deleteSavedAnnouncementSearchesById,
  getSavedAnnouncementSearches,
  getSavedAnnouncementSearchesById,
  getSavedAnnouncementSearchesByIdAnnouncements,
  postSavedAnnouncementSearches,
  putSavedAnnouncementSearchesById,
} from '@app/packages/api/v2/actions/saved_announcement_searches'
import type {
  SavedAnnouncementSearchesByIdAnnouncemenetsQuery,
  SavedAnnouncementSearchPostRequest,
  SavedAnnouncementSearchPutRequest,
} from '@app/packages/api/v2/types/params'

import {
  removeSavedAnnouncementSearchSlice,
  setSavedAnnouncementSearchesSlice,
  upsertSavedAnnouncementSearchSlice,
} from '@app/store/slices/saved_announcement_searches'
import { createThunk } from '@app/store/thunk'

import { callV2Api } from './api'

export const fetchSavedAnnouncementSearches = () =>
  createThunk(async dispatch => {
    const resp = await dispatch(callV2Api(getSavedAnnouncementSearches()))
    dispatch(setSavedAnnouncementSearchesSlice(resp.data))
    return resp
  })

export const fetchSavedAnnouncementSearch = (id: string) =>
  createThunk(async dispatch => {
    const resp = await dispatch(callV2Api(getSavedAnnouncementSearchesById(id)))
    dispatch(upsertSavedAnnouncementSearchSlice(resp.data))
    return resp
  })

export const createSavedAnnouncementSearch = (request: SavedAnnouncementSearchPostRequest) =>
  createThunk(async dispatch => {
    const resp = await dispatch(callV2Api(postSavedAnnouncementSearches(request)))
    dispatch(upsertSavedAnnouncementSearchSlice(resp.data))
    return resp
  })

/** The put answers with the search, but the screens reload it themselves, so nothing is written. */
export const updateSavedAnnouncementSearch = (id: string, request: SavedAnnouncementSearchPutRequest) =>
  createThunk(async dispatch => await dispatch(callV2Api(putSavedAnnouncementSearchesById(id, request))))

export const deleteSavedAnnouncementSearch = (id: string) =>
  createThunk(async dispatch => {
    const resp = await dispatch(callV2Api(deleteSavedAnnouncementSearchesById(id)))
    dispatch(removeSavedAnnouncementSearchSlice(id))
    return resp
  })

export const fetchSavedAnnouncementSearchAnnouncements = (id: string, query: SavedAnnouncementSearchesByIdAnnouncemenetsQuery) =>
  createThunk(async dispatch => await dispatch(callV2Api(getSavedAnnouncementSearchesByIdAnnouncements(id, query))))
